import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import axios from 'axios';
import { url } from '../utils/config';
import paymentDetailAtom from '../atoms/paymentDetailAtom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { toast } from 'react-toastify';
import appointmentDetailsAtom from '../atoms/appointmentDetailsAtom';
import Loader from './Loader';
const TapToPay = () => {
  const navigate = useNavigate();
  const [ paymentDetail, setPaymentDetail ] = useRecoilState(paymentDetailAtom);
  const appointmentDetails = useRecoilValue(appointmentDetailsAtom);
  const [showLoader,setShowLoader] =  useState(false); 

  console.log(appointmentDetails.id);
  const totalItems = 4;
  const totalAmount = 550.00;

  const handleTapToPay = async () => {
    
    setShowLoader(true);
    try {
      const reqUrl = url + `/complete_payment`;
      const token = window.localStorage.getItem('token');
      const headers = { authorization: `bearer ${token}` };
      console.log(reqUrl,token,headers);
      const res = await axios.post(reqUrl, {
         bill_id: paymentDetail.id,
         booking_id: appointmentDetails.id
         },{ headers });
      console.log(res);
      if(res.status === 200) {  
        toast.success(res.data.message,{autoClose: 2000});
        navigate('/payment_successful');
        setPaymentDetail(null);
      }
      else {
        toast.error(res.data.message,{autoClose: 2000});
      }
    } catch (error) {
      console.log(error);
    }
    setShowLoader(false);
  };

  return (
    <div className="h-[calc(100vh-64px)] flex flex-col bg-white p-4">
      {/* Blue Header with Total */}
   
    {showLoader ? <Loader /> : 
      <>
   <div className="bg-blue-600 text-white rounded-lg p-4 flex justify-between items-center">
          <div className="font-medium">
          Total Amount | ${paymentDetail.amount.toFixed(2)}
          </div>
          <button 
            className="bg-white text-blue-800 px-4 py-1 rounded-md text-sm font-medium"
            onClick={() => navigate('/view_estimate')}
          >
            View Estimate
          </button>
        </div>

      {/* Total Amount Display */}
      <div className="text-center mt-6">
        <p className="text-gray-600 text-sm">Total</p>
        <p className="text-2xl font-bold">${paymentDetail.amount.toFixed(2)}</p>
      </div>

      {/* Card Illustration */}
      <div className="flex-1 flex flex-col items-center justify-center" onClick={handleTapToPay}>
        <div className="relative mb-6">
          {/* Phone outline */}
          <div className="w-48 h-72 border-2 border-gray-800 rounded-3xl relative">
            {/* Phone screen */}
            <div className="absolute top-4 left-4 right-4 bottom-4 bg-gray-100 rounded-2xl"></div>
            
            {/* Credit card */}
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-56 h-36 bg-green-400 rounded-xl shadow-lg rotate-90 flex flex-col justify-between p-4">
              {/* Card chip */}
              <div className="w-8 h-6 bg-yellow-200 rounded-sm"></div>
              
              {/* Card number */}
              <div className="flex space-x-2">
                <div className="w-10 h-3 bg-white rounded-sm opacity-70"></div>
                <div className="w-10 h-3 bg-white rounded-sm opacity-70"></div>
                <div className="w-10 h-3 bg-white rounded-sm opacity-70"></div>
                <div className="w-10 h-3 bg-white rounded-sm opacity-70"></div>
              </div>
              
              {/* Card details */}
              <div className="flex justify-between items-end">
                <div className="space-y-1">
                  <div className="w-16 h-2 bg-white rounded-sm opacity-70"></div>
                  <div className="w-12 h-2 bg-white rounded-sm opacity-70"></div>
                </div>
                <div className="w-8 h-8 rounded-full bg-red-500 opacity-80"></div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Tap to Pay Text */}
        <p className="text-gray-700 text-lg font-medium">Click on Card To Complete Payment</p>
      </div>

      {/* Back Button */}
      <div className="p-4">
        <button 
          onClick={() => navigate(-1)}
          className="p-2 bg-gray-100 rounded-full"
        >
          <FaArrowLeft className="text-gray-700" />
        </button>
      </div>
      </>
}
    </div>

  );
};

export default TapToPay;